import React from "react";
import { QuestionBlock } from "../../components/questionBlock/questionBlock";

import "./faq.scss";
export const Faq = () => {
  return (
    <>
      <div className="Frequently_asked">
        <div className="container">
          <h2>Frequently Asked Questions</h2>
          <p>
            Mation ullamco laboris nisi ut aliquip exea core dolor in repre
            <br></br>
            hender fugiat nulla pariatur.
          </p>
          <div className="frequant_asked_content">
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div className="row">
                  <div className="question_block col-lg-12 col-md-12 col-sm-12">
                    <QuestionBlock
                      question={
                        "Why Ulina is the best choice for your website?"
                      }
                      answer={
                        "Virure dolor in rep rehenderit in voluptate vinim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo cnsequat. Duis aute irure dolor in reprehen."
                      }
                    />
                  </div>

                  <div className="question_block col-lg-12 col-md-12 col-sm-12">
                    <QuestionBlock
                      question={"Why Ulina is the best choice for your "}
                      answer={
                        "Virure dolor in rep rehenderit in voluptate vinim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo cnsequat. Duis aute irure dolor in reprehen."
                      }
                    />
                  </div>

                  <div className="question_block col-lg-12 col-md-12 col-sm-12">
                    <QuestionBlock
                      question={"How can we get the best from Ulina template?"}
                      answer={
                        "Virure dolor in rep rehenderit in voluptate vinim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo cnsequat. Duis aute irure dolor in reprehen."
                      }
                    />
                  </div>

                  <div className="question_block col-lg-12 col-md-12 col-sm-12">
                    <QuestionBlock
                      question={
                        "Why Ulina is so popular among all other template? "
                      }
                      answer={
                        "Virure dolor in rep rehenderit in voluptate vinim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo cnsequat. Duis aute irure dolor in reprehen."
                      }
                    />
                  </div>

                  <div className="question_block col-lg-12 col-md-12 col-sm-12">
                    <QuestionBlock
                      question={"What Payment Methods Are Available?"}
                      answer={
                        "Virure dolor in rep rehenderit in voluptate vinim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo cnsequat. Duis aute irure dolor in reprehen."
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 Havequestion">
                <h3>Have Any Qustion</h3>
                <form>
                  <label>First Name *</label>
                  <input type="text" placeholder="Demo Name" required></input>
                  <label>Email Address *</label>
                  <input
                    type="e-mail"
                    placeholder="info@quomodosoft.com"
                    required
                  ></input>
                  <label>Message</label>
                  <textarea placeholder="type Your Mesage Here"></textarea>
                  <button>Send Now</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
